module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding-bottom": "10px"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Mike was born in London and raised happily in Surbiton. He left the grammar school at 18 and joined the regular army straight from school. He volunteered to serve in Aden (now Yemen) so as to join his fiancée who had already been posted there. She gave him the ring back on the night he got there and his subsequent adventures in a war for two years can be read in the first book in this trilogy"), _c('em', [_vm._v(", It must have been the compo")]), _vm._v(". This, second book relates our hero Jack’s adventures for 6 months in a brutal training regime to become an officer following his recommendation for a commission in Aden. Subsequent service in the Depot (the now notorious Deepcut!), the Junior Leaders’ Regiment and a tank depot followed. A varied career with a N. Ireland Training Board, a group training association, as Personnel Director and Tribunal Advocate resulted in writing the Dear Doctor employment law column in the Sunday Times for 10 years. This is his second venture into fiction with a third in the trilogy to follow.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0